import { createContext, useContext } from 'react';
export const ImportContext = createContext(null);
export function useImport() {
    const context = useContext(ImportContext);
    if (!context) {
        throw new Error('useImport must be used within a ImportContext');
    }
    return context;
}
